import env from 'config/env';

/**
 * Resolve a server media path to a browser-loadable URL.
 *
 * The backend returns RELATIVE paths for uploaded files (e.g.
 * "/mentors/files/<id>/photo/<f>.png"). Rendered directly in an <img>, those
 * resolve against the app origin (:3000) instead of the API origin, so the
 * image 404s. Prefix relative paths with the image/API base URL.
 *
 * Absolute URLs (http/https), data: URIs and blob: previews (staged local
 * files from URL.createObjectURL) are returned unchanged.
 */
export const resolveMediaUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  const base = (env.imageBaseUrl || env.apiBaseUrl || '').replace(/\/$/, '');
  if (!base) return url;
  return url.startsWith('/') ? `${base}${url}` : `${base}/${url}`;
};

export default resolveMediaUrl;
